<template>
  <div @click="touch">
    <div class="md-layout md-gutter md-alignment-center-center splash-content">
      <div class="md-layout-item md-size-100">
        <md-empty-state>
          <img src="@/assets/icons/ministero-logo.png" class="ministero-logo" alt="ministero-logo">
        </md-empty-state>
      </div>

      <div class="md-layout-item md-size-100">
        <md-empty-state>
          <img src="@/assets/icons/icon.png" class="app-logo" alt="app-logo">
          <h3>ZANA</h3>
        </md-empty-state>
      </div>

      <div class="md-layout-item md-size-100">
        <md-empty-state>
          <h6>powered by</h6>
          <img src="@/assets/icons/arcadia-logo.png" class="arcadia-logo" alt="arcadia-logo">
        </md-empty-state>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted () {
    document.body.classList.add('splash')
    document.body.children[1].classList.add('splash-content')
  },
  methods: {
    touch: function (event) {
      document.body.classList.remove('splash')
      document.body.children[1].classList.remove('splash-content')
      this.$emit('splash')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/arcadia_theme.scss';

  .ministero-logo {
    width: 80%;
  }

  .arcadia-logo {
    width: 40%;
  }

  .app-logo {
    width: 40%;
  }

  .splash-content {
    height: -webkit-fill-available;
    height: -moz-available;
    height: stretch;
  }
</style>
